import { NotificationService } from '@/services/notification.service';
import { queryOptions } from '@tanstack/react-query';

const NOTIFICATION_QUERY_DEFAULTS = {
  retry: false,
  staleTime: 30_000,
  refetchInterval: 60_000,
  refetchOnWindowFocus: true,
} as const;

export const notificationQueryKeys = {
  all: ['notifications'] as const,
  user: (viewerId?: string | null) => [...notificationQueryKeys.all, viewerId ?? null] as const,
  list: (viewerId?: string | null, limit = 20) => [...notificationQueryKeys.user(viewerId), 'list', limit] as const,
  summary: (viewerId?: string | null) => [...notificationQueryKeys.user(viewerId), 'summary'] as const,
};

export const notificationQueryOptions = {
  list: (viewerId?: string | null, limit = 20, enabled = true) =>
    queryOptions({
      queryKey: notificationQueryKeys.list(viewerId, limit),
      queryFn: () => NotificationService.list(limit),
      enabled: enabled && Boolean(viewerId),
      ...NOTIFICATION_QUERY_DEFAULTS,
    }),
  summary: (viewerId?: string | null, enabled = true) =>
    queryOptions({
      queryKey: notificationQueryKeys.summary(viewerId),
      queryFn: NotificationService.summary,
      enabled: enabled && Boolean(viewerId),
      ...NOTIFICATION_QUERY_DEFAULTS,
    }),
};
